/* import __COLOCATED_TEMPLATE__ from './adc-noise-bandwidth.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import PrettyNum from '../utils/pretty-num-wrapper';

export default class AdcNoiseBandwidth extends Component {
    tagName = '';

    @service intl;
    @service('data') model;
    @service sigmaDeltaData;

    @computed('model.filterBandwidth') get rcFilterEquivBw() {
        if (!(this.model.filterBandwidth || this.model.filterBandwidth === 0)) {
            return null;
        }
        return this.model.filterBandwidth * 1.57;
    }

    @computed('rcFilterEquivBw', 'model.samplingRate') get numberOfAliasedPassbands() {
        if (
            !(this.rcFilterEquivBw || this.rcFilterEquivBw === 0) ||
            !(this.model.samplingRate || this.model.samplingRate === 0)
        ) {
            return null;
        }

        return Math.ceil(this.rcFilterEquivBw / this.model.samplingRate) + 1;
    }

    @computed('rcFilterEquivBw') get prettyRcFilterEquivBw() {
        return `${PrettyNum.eng3(this.rcFilterEquivBw)}${this.intl.t('units.hz')}`;
    }

    @computed('model.noiseCalculations.adc.equivBW') get prettyAdcEquivBw() {
        return `${PrettyNum.eng3(this.model.noiseCalculations.adc.equivBW)}${this.intl.t('units.hz')}`;
    }

    @computed('model.samplingRate') get prettySamplingRate() {
        return `${PrettyNum.eng3(this.model.samplingRate)}${this.intl.t('units.hz')}`;
    }

    @computed('numberOfAliasedPassbands') get prettyNumberOfAliasedPassbands() {
        return `${PrettyNum.eng3(this.numberOfAliasedPassbands)}`;
    }

    @computed('model.noiseCalculations.rfilt.effectiveBW') get prettyEffectiveBW() {
        return `${PrettyNum.eng3(this.model.noiseCalculations.rfilt.effectiveBW)}${this.intl.t('units.hz')}`;
    }
}
